module.exports = __webpack_public_path__ + "resources/img/img_cloud_moa1.b567842f5dedf58be943dbb7aa30feee.png";